<template>
  <b-card class="box">
    <template v-slot:header>
      <h4>Benutzer Konto</h4>
    </template>
    <table>
      <tr v-for="(item,key) in $currentUser"
           :key="key"
            v-if="['first_name','last_name','email'].includes(key)">
            <td>{{item}}</td>
      </tr>
      <hr>
      <tr>
        <td>{{$currentUser.street}} {{$currentUser.number}}</td>
      </tr>
      <tr>
        <td>{{$currentUser.zip}} {{$currentUser.city}}</td>
      </tr>
    </table>

  </b-card>
</template>

<script>
    export default {
        name: "luma-user-info"
    }
</script>

<style scoped>

  .box{
    text-align: left;
    min-width: 180px;
    /*min-height: 180px;*/
    max-width: 220px;
    min-height: 220px;

  }

</style>



// WEBPACK FOOTER //
// src/views/General/luma-user-info.vue